"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryPermissions = void 0;

var _common = require("./../common");

var _service = require("./../service");

class BasisTheoryPermissions extends _service.BasisTheoryService {
  list(query, options) {
    const url = `/${(0, _common.getQueryParams)(query)}`;
    return this.client.get(url, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

}

exports.BasisTheoryPermissions = BasisTheoryPermissions;